var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{style:(_vm.noPadding === 'true' ? 'padding: 0;' : 'padding: 8px;'),attrs:{"fluid":""}},[_c('v-layout',{style:('max-height: ' + _vm.maxHeight + ';')},[_c('v-flex',{staticStyle:{"overflow-y":"auto"}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5595ed60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentArea.vue
// module id = null
// module chunks = 